import {Component, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {DxFormComponent} from 'devextreme-angular/ui/form';
import {DxDataGridComponent} from 'devextreme-angular/ui/data-grid';
import {AjaxService} from 'AjaxService';
import {EntityArt} from '@enums/entityArt.enum';
import {MitarbeiterAngaben} from './mitarbeiter-personal.model';

@Component({
  selector: 'cz-mitarbeiter-angaben',
  templateUrl: './mitarbeiter-angaben.component.html',
  styleUrls: ['./mitarbeiter-angaben.component.css'],
  standalone: false,
})
export class MitarbeiterAngabenComponent implements OnInit {
  @Input() model: MitarbeiterAngaben;
  @Input() showWerdegang = false;
  @Input() readOnly = false;
  @ViewChildren(DxFormComponent) forms: QueryList<DxFormComponent>;
  @ViewChild(DxDataGridComponent) werdegang: DxDataGridComponent;
  ausbildungen: any[] = [];
  loadError = false;
  loadingAusbildungen = true;
  minDate = new Date(1900, 0, 1);
  today = new Date();
  geburtsdatumValidation = ({value}: {value: string | Date}) => {
    const date = new Date(value);
    return date >= this.minDate && date <= this.today;
  };
  eintraege = [{value: 1, text: 'Keine Einträge'}, {value: 2, text: 'Einträge vorhanden'}];
  private nextId = -1;
  invalidSection = 'personal-person';

  get werdegangVisible(): boolean { return this.showWerdegang || this.hasPendingWerdegang(); }
  get ausbildungsortRequired(): boolean {
    return this.ausbildungen.some(item => this.model?.ausbildungIds?.includes(item.id) && item.param?.askForAusbildungsort === true);
  }

  constructor(private ajax: AjaxService) {}

  ngOnInit() {
    this.ajax.post<any[]>('api/Options/GetEntityForSelectEdit', EntityArt.Ausbildung).subscribe({
      next: items => { this.ausbildungen = items; this.loadingAusbildungen = false; },
      error: () => { this.loadError = true; this.loadingAusbildungen = false; },
    });
  }

  addWerdegang(event: any) {
    event.data.id = this.nextId--;
    event.data.von = null;
    event.data.bis = null;
    event.data.bisJetzt = false;
  }

  onFieldDataChanged(event: {dataField?: string; value?: unknown}) {
    if (event.dataField) Object.assign(this.model, {[event.dataField]: event.value});
  }

  async validate(): Promise<boolean> {
    if (this.loadingAusbildungen || this.loadError) { this.invalidSection = 'personal-ausbildung'; return false; }
    const results = this.forms?.map(form => form.instance.validate().isValid);
    if (!results?.length || !results.every(Boolean)) {
      this.invalidSection = ['personal-person', 'personal-ausbildung', 'personal-bestaetigungen'][Math.max(0, results?.findIndex(valid => !valid) ?? 0)];
      return false;
    }
    if (this.werdegang) {
      await this.werdegang.instance.saveEditData();
      if (this.werdegang.instance.hasEditData()) { this.invalidSection = 'personal-werdegang'; return false; }
    }
    return true;
  }

  hasPendingWerdegang(): boolean {
    return this.werdegang?.instance.hasEditData() ?? false;
  }
}
